import RouterNode from './router/index';
import './App.css';

const App = () => {
  return (
    <RouterNode />
  );
};

export default App;
